const $ = require('jquery');
const getCountText = require('./getCountText');

module.exports = function animateResultsText(element, count) {
    $(element).velocity({
        opacity: [0, 1],
    }, {
        duration: 600,
        easing: 'ease-in-out',
        complete: onFadeOut
    });

    function onFadeOut() {
        const text = getCountText(count);
        element.textContent = text;
        $(element).velocity({
            opacity: [1, 0],
        }, {
            duration: 600,
            easing: 'ease-in-out'
        });
    }
};
